export function successAccountCreationReducer (state, action) {
    switch(action.type) {
        case "SET_IS_ACCOUNT_ENABLED":
            return { ...state, isAccountEnabled: action.payload}
        case "SET_ACCOUNT_CREATION_MESSAGE":
            return { ...state, accountCreationMsg: action.payload}
    }
}
